module.exports = __webpack_public_path__ + "img/main.b94e7ee8.png";